import http from "../../utils/httpClient";

class blogService {
  createOrUpdateBlogCategory = async (data) => {
    return await http.post("/api/Content/CreateOrUpdateBlogCategory", data);
  };

  getBlogCategory = async () => {
    return await http.get("/api/Content/GetBlogCategory", {
      params: { getAll: "Y" },
    });
  };

  createOrUpdateBlogPost = async (data) => {
    return await http.post("/api/Content/AddOrUpdateBlogPost", data);
  };

  getBlogPost = async (data) => {
    return await http.get("/api/Content/GetBlogPost", {
      params: data,
    });
  };
}

export default new blogService();
